$primary: #82bc44;
$info: #3b82f6;
$warning: #f59e0b;
$text: #111827;
$hover: #f3f4f6;

.wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-start;
	gap: 0.75rem;
	padding: 0.25rem 0.75rem;
}

.actions {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
}

.action {
	display: flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.4rem 0.8rem;
	border-radius: 0.5rem;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	border: 1px solid #e5e7eb;
	background-color: #f9fafb;
	color: $text;
	transition:
		background-color 0.2s ease,
		color 0.2s ease,
		border-color 0.2s ease;

	&:hover {
		background-color: rgba(130, 188, 68, 0.08);
		border-color: $primary;
		color: $primary;

		svg {
			color: $primary;
		}
	}
}

.icon {
	color: inherit;
	transition: color 0.2s ease;
}

.actionPrimary {
	color: darken($primary, 5%);
	border-color: rgba(130, 188, 68, 0.45);
	background-color: rgba(130, 188, 68, 0.08);

	&:hover {
		background-color: rgba(130, 188, 68, 0.18);
		border-color: $primary;
		color: darken($primary, 10%);

		svg {
			color: darken($primary, 10%);
		}
	}
}

.actionInfo {
	color: $info;
	border-color: rgba(59, 130, 246, 0.4);
	background-color: rgba(59, 130, 246, 0.07);

	&:hover {
		background-color: rgba(59, 130, 246, 0.15);
		border-color: $info;
		color: darken($info, 8%);

		svg {
			color: darken($info, 8%);
		}
	}
}

.actionWarning {
	color: darken($warning, 5%);
	border-color: rgba(245, 158, 11, 0.4);
	background-color: rgba(245, 158, 11, 0.07);

	&:hover {
		background-color: rgba(245, 158, 11, 0.15);
		border-color: $warning;
		color: darken($warning, 10%);

		svg {
			color: darken($warning, 10%);
		}
	}
}
